module.exports = __webpack_public_path__ + "static/diorama-652c41ef3702a6e2299a69184cf3db40.jpg";